<template>
  <div class="container h-100">
    <!-- <div>all</div> -->
    <div class="row h-100 justify-content-center align-items-center">
      <div class="col-lg-5">
        <div class="card card-custom shadow">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-lg-12 my-5" v-if="getIsCod">
                <div class="mx-4">
                  <div class="my-5">
                    <span class="icon status-icon submitted-icon"></span>
                  </div>

                  <h4 class="text-center fw-bolder text-navy-blue">
                    Application Submitted
                  </h4>
                  <div class="text-center mt-3">
                    <strong>Dear, {{ applicationData.firstName }}</strong>
                  </div>
                  <div class="text-center mt-3">
                    Thank you! Your application number is
                    <span class="text-color-orange fw-bold">{{
                      GET_PREDATA.referenceNumber
                    }}</span>
                  </div>
                  <div class="text-center mt-3">
                    Selected application package:
                    <strong>
                      {{ getDataPack.subDesc }}
                      <!-- <span v-if="getDataPack.isWithDevice">
                        with Xperience Hub</span
                      > -->
                    </strong>
                  </div>
                  <div class="text-center mt-3">
                    Prefered Date and Time of Installation is:
                    <strong>{{ GET_CODRESPONSE }}</strong>
                  </div>

                  <div
                    class="text-center mt-3"
                    v-if="getAffiliateCode && getAffiliateCode.trim()"
                  >
                    Affilliate Code:
                    <span class="text-color-orange fw-bold">{{
                      getAffiliateCode
                    }}</span>
                  </div>

                  <div class="text-center mt-3">
                    Please expect a call from our customer support team.
                  </div>

                  <div class="text-center mt-5">
                    Thank you for choosing Surf2Sawa!
                  </div>
                  <div class="text-center mt-3">
                    <strong>Surf2Sawa Team</strong>
                  </div>
                  <!-- 
                  <div class="text-center mt-3">
                    Application Reference Number
                    <div class="reference-number">{{ refNumber }}</div>
                  </div> -->

                  <div class="my-5 text-center">
                    <button
                      class="btn px-5 btn-s2s-blue"
                      @click.prevent="goBack()"
                    >
                      Done
                    </button>
                  </div>
                  <hr />
                </div>
              </div>

              <div class="col-lg-12 my-5" v-else>
                <div class="mx-4">
                  <div class="my-5">
                    <span class="icon status-icon submitted-icon"></span>
                  </div>

                  <h4 class="text-center fw-bolder text-navy-blue">
                    Application Submitted
                  </h4>
                  <div class="text-center mt-3">
                    <strong>Dear, {{ applicationData.firstName }}</strong>
                  </div>

                  <div class="text-center mt-3">
                    Your payment of
                    <strong v-if="getDataPack.skuName === 'Extraboost'"
                      >Php {{ getDataPack.totalCost }}</strong
                    >
                    <strong v-else>Php {{ getDataPack.price }} </strong>
                    was successfully processed! Your application number is:
                    <span class="text-orange fw-bold"> {{ getRefNumber }}</span>
                  </div>

                  <div class="text-center mt-3">
                    Please save your application number for any inquiries you
                    may have about your application.
                  </div>
                  <div class="text-center mt-3">
                    Kindly give us 3 to 5 days to install your prepaid internet.
                    A representative will give you updates on your application
                    so make sure to keep your lines open.
                  </div>

                  <div
                    class="text-center mt-3"
                    v-if="getAffiliateCode && getAffiliateCode.trim()"
                  >
                    Affilliate Code:
                    <span class="text-color-orange fw-bold">{{
                      getAffiliateCode
                    }}</span>
                  </div>

                  <div class="text-center mt-5">
                    Thank you for choosing Surf2Sawa!
                  </div>
                  <div class="text-center mt-3">
                    <strong>Surf2Sawa Team</strong>
                  </div>
                  <!--  <div class="text-center mt-3">
                    Application Reference Number
                    <div class="reference-number">{{ refNumber }}</div>
                  </div> -->

                  <div class="my-5 text-center">
                    <button
                      class="btn px-5 btn-s2s-blue"
                      @click.prevent="goBack()"
                    >
                      Done
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <change-nap-modal ref="refChangeNap"></change-nap-modal>
    <activate-modal ref="refActivateModal"></activate-modal>
    <change-onu-modal ref="refChangeOnuModal"></change-onu-modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import ChangeNapModal from "../components/ChangeNapModal.vue";
import ActivateModal from "../components/ActivateModal.vue";
import ChangeOnuModal from "../components/ChangeOnuModal.vue";

export default {
  components: {
    ChangeNapModal,
    ActivateModal,
    ChangeOnuModal,
  },

  data() {
    return {
      modalMaps: {
        isShow: false,
      },

      refNumber: "",
      submitted: false,

      btnLoading: false,

      portReserveResponse: {},
    };
  },

  methods: {
    async changeOnu() {
      this.btnLoading = true;

      this.$refs.refChangeOnuModal
        .open()
        .then(async (result) => {
          console.log(result);

          if (result.status) {
            const { data } = result;
            await this.callChangeOnu(data);
          }
        })
        .catch((err) => {
          console.log(err);
          this.btnLoading = false;
        });
    },

    async callChangeOnu(payload) {
      this.btnLoading = true;
      await this.$niap
        .post("/change-onu", payload)
        .then((response) => {
          this.btnLoading = false;

          const res = response.data;

          if (!res.status) {
            this.$swal("Sorry", res.message, "error");
            return;
          }

          this.$swal("Success", res.message, "success");
        })
        .catch((e) => {
          this.btnLoading = false;
          console.log(e);
        });
    },

    async portRelease() {
      this.btnLoading = true;
      const payload = {
        NAPPortNo: this.GET_PREDATA.nap.availablePortNo,
        referenceNo: this.GET_PREDATA.referenceNumber,
      };

      await this.$niap
        .post("/port-release", payload)
        .then((response) => {
          console.log(response);
          this.btnLoading = false;

          const res = response.data;

          if (!res.status) {
            this.$swal("Sorry", res.message, "error");
            return;
          }

          this.$swal("Success", res.message, "success");
        })
        .catch((e) => {
          this.btnLoading = false;
          console.log(e);
        });
    },

    async portReserve() {
      this.btnLoading = true;
      const payload = {
        latitude: this.GET_PREDATA.latitude,
        longitude: this.GET_PREDATA.longitude,
        accountName: `${this.GET_PREDATA.stepData.firstName} ${this.GET_PREDATA.stepData.lastName}`,
        locationType: this.GET_PREDATA.stepData.locationType,
        locationCode: this.GET_PREDATA.stepData.buildingOrSubdiviCode,
        referenceNo: this.GET_PREDATA.referenceNumber,
      };

      await this.$niap
        .post("/port-reserve", payload)
        .then((response) => {
          console.log(response);
          this.btnLoading = false;

          const res = response.data;

          if (!res.status) {
            this.$swal("Sorry", res.message, "error");
            return;
          }

          this.portReserveResponse = res.data;
          this.$store.dispatch("ADD_PORT_RESERVATION", res.data);

          this.$swal("Success", res.message, "success");
        })
        .catch((e) => {
          this.btnLoading = false;
          console.log(e);
        });
    },

    reFormatNumber(num) {
      // return num.replace(/\s+/g, "").replace("0", "");
      if (num && num.indexOf("63") == 0) {
        return num.replace(/\s+/g, "");
      }
      return "63" + num.substring(1).replace(/\s+/g, "");
    },

    async allocate() {
      this.btnLoading = true;
      const portReserveResponse = this.$store.getters.GET_PORT_RESERVATION;
      const pr = portReserveResponse.portReserve;

      console.log(this.GET_PREDATA);
      const payload = {
        NAPPortNo: this.GET_PREDATA.nap.availablePortNo,
        referenceNo: this.GET_PREDATA.referenceNumber,
        accountName: `${this.GET_PREDATA.stepData.firstName} ${this.GET_PREDATA.stepData.lastName}`,
        accountNumber: pr.referenceNo,
        reservationNo: pr.esb.reservationNo,
        RegionCode: this.GET_PREDATA.stepData.regionCode,
        ProvinceCode: this.GET_PREDATA.stepData.provinceCode,
        CityCode: this.GET_PREDATA.stepData.cityCode,
        BarangayCode: this.GET_PREDATA.stepData.barangayCode,
        Subdivision: this.GET_PREDATA.stepData.buildingOrSubdivision,
        Address: this.applicationData.address,
        Latitude: this.GET_PREDATA.latitude,
        Longitude: this.GET_PREDATA.longitude,
        CustomerPhoneNumber: this.reFormatNumber(
          this.GET_PREDATA.stepData.mobileNumber
        ),
      };

      // console.log("allocate", payload)

      await this.$niap
        .post("/port-allocate", payload)
        .then((response) => {
          console.log(response);
          this.btnLoading = false;

          const res = response.data;

          if (!res.status) {
            this.$swal("Sorry", res.message, "error");
            return;
          }

          this.$swal("Success", res.message, "success");
        })
        .catch((e) => {
          this.btnLoading = false;
          console.log(e);
        });
    },

    async changeNap() {
      console.log(this.portReserveResponse);
      const portReserveResponse = this.$store.getters.GET_PORT_RESERVATION;
      const pr = portReserveResponse.portReserve;
      this.$refs.refChangeNap.open(portReserveResponse).then((result) => {
        if (result.status) {
          // const { esb } = portReserveResponse.portReserve;

          const payload = {
            accountNumber: pr.referenceNo,
            oldNAPPortNo: pr.esb.nap_code,
            desiredNAPPortNo: result.data.napPort,
            referenceNo: this.GET_PREDATA.referenceNumber,
          };

          console.log(result);

          this.changeNapCall(payload);
        }
      });
    },

    async changeNapCall(payload) {
      this.btnLoading = true;

      await this.$niap
        .post("/change-nap", payload)
        .then((response) => {
          console.log(response);
          this.btnLoading = false;

          const res = response.data;

          if (!res.status) {
            this.$swal("Sorry", res.message, "error");
            return;
          }

          const predata = { ...this.GET_PREDATA };
          predata.nap.availablePortNo = payload.desiredNAPPortNo;
          this.$store.dispatch("ADD_PREDATA", predata);

          const portRes = { ...this.$store.getters.GET_PORT_RESERVATION };

          portRes.portReserve.esb.nap_code = payload.desiredNAPPortNo;
          this.$store.dispatch("ADD_PORT_RESERVATION", portRes);
          this.$swal("Success", res.message, "success");
        })
        .catch((e) => {
          this.btnLoading = false;
          console.log(e);
        });
    },

    async activate() {
      // this.btnLoading = true;

      this.$refs.refActivateModal
        .open()
        .then((result) => {
          const payload = {
            NAPPortNo: this.GET_PREDATA.nap.availablePortNo,
            package: "S2S 25MBPS",
            productType: "Residential",
            // onuSN: "",
            // OLTPort: "",
            referenceNo: this.GET_PREDATA.referenceNumber,
          };
          if (result.status) {
            // const { esb } = portReserveResponse.portReserve;

            payload.onuSN = result.data.serialNumber;
            payload.OLTPort = result.data.oltPort;
            payload.ONUVendor = result.data.ONUVendor;

            this.callActivate(payload);
            // console.log("activate", payload)
          }
        })
        .catch((err) => {
          console.log(err);
        });

      // const payload = {
      //   NAPPortNo: this.GET_PREDATA.nap.availablePortNo,
      //   referenceNo: this.GET_PREDATA.referenceNumber,
      //   accountName: `${this.GET_PREDATA.stepData.firstName} ${this.GET_PREDATA.stepData.lastName}`,
      //   accountNumber: "1234567",
      //   reservationNo: "f3a02558-bb66-49",
      // };
      // await this.$niap
      //   .post("/port-allocate", payload)
      //   .then((response) => {
      //     console.log(response);
      //     this.btnLoading = false;
      //     const res = response.data;
      //     if (!res.status) {
      //       this.$swal("Sorry", res.message, "error");
      //       return;
      //     }
      //     this.$swal("Success", res.message, "success");
      //   })
      //   .catch((e) => {
      //     this.btnLoading = false;
      //     console.log(e);
      //   });
    },

    async callActivate(payload) {
      this.btnLoading = true;

      await this.$niap
        .post("/resource-update", payload)
        .then((response) => {
          console.log(response);
          this.btnLoading = false;

          const res = response.data;

          if (!res.status) {
            this.$swal("Sorry", res.message, "error");
            return;
          }

          this.$swal("Success", res.message, "success");
        })
        .catch((e) => {
          this.btnLoading = false;
          console.log(e);
        });
    },

    goBack() {
      this.$store.dispatch("ADD_PREDATA", null);
      this.$store.dispatch("ADD_AFFILIATECODE", "");
      this.$store.dispatch("ADD_IS_COD", false);
      this.$store.dispatch("ADD_COD_RESPONSE", {});
      this.$store.dispatch("ADD_PORT_RESERVATION", {});
      this.$store.dispatch("ADD_APPLICATION_FORM", false).then(() => {
        this.$router.push({ path: "/" });
      });
    },

    reFormatAccountNumber(num) {
      return num.replace(/\s+/g, "").replace("+", "");
    },

    installaDate() {},
  },

  created() {
    // const refNumber = this.$store.getters.GET_REFNUMBER;
    // if (refNumber) {
    //   this.refNumber = refNumber;
    // } else {
    //   this.$router.push({ path: "/" });
    // }
    //
    const appData = this.$store.getters.GET_APPLICATIONFORMDATA;
    const isEmpty = Object.keys(appData).length === 0;
    if (isEmpty) {
      this.$router.push({ path: "/" });
      return;
    }
  },

  computed: {
    applicationData() {
      return this.$store.getters.GET_APPLICATIONFORMDATA;
    },

    getDataPack() {
      return this.$store.getters.GET_DATAPACK;
    },

    getRefNumber() {
      return this.$store.getters.GET_REFNUMBER;
    },

    getAffiliateCode() {
      return this.$store.getters.GET_AFFILIATECODE;
    },

    getIsCod() {
      return this.$store.getters.GET_ISCOD;
    },

    GET_PREDATA() {
      return this.$store.getters.GET_PREDATA;
    },

    GET_CODRESPONSE() {
      const res = this.$store.getters.GET_CODRESPONSE;
      return moment(res.installationDate).format("dddd MMM. DD, YYYY hh:mm A");
    },
  },

  validations: {
    accountNumber: {
      required,
    },
  },
};
</script>

<style scoped>
/* @import "../assets/css/reset.css";
@import "../assets/css/sweetalert2.min.css";
@import "../assets/css/superwheel.min.css"; */

.text-color-orange {
  color: #ff7200;
}
</style>
